import React from "react";
import { useSelector } from "react-redux";
import { selectBemessungenMikropfaehle } from "../store/slices/bemessungenMikropfaehleSlice";

// TODO: combine with bemessungenMikropfaehleSlice.js
export enum BM_TYP {
  EUROCODE_7 = 0,
  GERMANY = 1,
  AASHTO = 2,
}

type Props = {
  types: Array<BM_TYP>;
  children: React.ReactNode;
};

// Default: dont render anything
function RenderFor(props: Props) {
  const bemessungenMikropfaehle = useSelector(selectBemessungenMikropfaehle);

  if (!props.types || props.types.length === 0) {
    return null;
  }

  for (let index = 0; index < props.types.length; index++) {
    const element = props.types[index];

    if (Number(bemessungenMikropfaehle) === element) {
      return <>{props.children}</>;
    }
  }

  return null;
}

export default RenderFor;
